var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlyingTakingOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.31689 11.4147L3.97772 13.6507C4.11303 13.8329 4.35408 13.9011 4.56479 13.8168L9.5671 11.8161L15.7057 9.36978C16.4849 9.05927 17.3406 8.31051 16.8407 7.63699C16.761 7.52953 16.6634 7.43802 16.5558 7.36309C16.0955 7.04259 15.4919 7.2161 14.9659 7.41068L11.8844 8.5507C11.7262 8.60922 11.5492 8.58406 11.4136 8.48379L6.12476 4.5728C5.98623 4.47035 5.80472 4.44645 5.64439 4.50954L5.08803 4.72847C4.78168 4.84902 4.67342 5.2276 4.86972 5.49188L7.82546 9.47127C8.02094 9.73445 7.91451 10.1114 7.61024 10.2335L4.81852 11.3535C4.66756 11.414 4.49657 11.3974 4.36013 11.3088L3.25807 10.5935C3.12338 10.5061 2.95491 10.4886 2.80519 10.5467L2.53762 10.6503C2.22964 10.7697 2.11995 11.1496 2.31689 11.4147Z",
    fill: "#FFFFFE",
    stroke: "#FFFFFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08203 18H16.082",
    stroke: "#FFFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlyingTakingOff);
export default __webpack_public_path__ + "static/media/flying-taking-off.5ce36fddac47627f01f0fcee9d312ed8.svg";
export { ForwardRef as ReactComponent };